import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            height: 'auto',
            overflow: 'hidden',
            minW: remCalc(260),
            minH: remCalc(260),
            maxW: '100%',
            maxH: '100%',
        },
    },
    variants: {
        inModal: {
            container: {
                width: '100%',
                height: 'auto',
                minW: 0,
                minH: 0,
                marginLeft: 'auto',
                marginRight: 'auto',
                maxW: {
                    base: '100%',
                    sm: '100%',
                    md: remCalc(616),
                    lg: remCalc(625),
                    xl: remCalc(720),
                },
                maxH: {
                    base: '100%',
                    sm: '100%',
                    md: remCalc(616),
                    lg: remCalc(625),
                    xl: remCalc(720),
                },
                maxWidth: {
                    base: '100%',
                    sm: '100%',
                    md: remCalc(616),
                    lg: remCalc(625),
                    xl: remCalc(720),
                },
                maxHeight: {
                    base: '100%',
                    sm: '100%',
                    md: remCalc(616),
                    lg: remCalc(625),
                    xl: remCalc(720),
                },
            },
        },
        plpCarousel: {
            container: {
                maxW: {
                    base: '100%',
                    md: remCalc(386),
                    lg: remCalc(386),
                    xl: remCalc(570),
                },
                maxH: {
                    base: '100%',
                    md: remCalc(386),
                    lg: remCalc(386),
                    xl: remCalc(570),
                },
            },
        },
    },
    parts: ['container'],
}
